// 获取面包屑
export const breadcrumb = state => state.breadcrumb

export const userInfo = state => state.userInfo

export const isLogin = state => state.isLogin

// export const currentUserId = state => state.currentUserId
